// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2x5Tf","footer":"ModalError_footer__1Z81s"};